"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _EditChecklist = _interopRequireDefault(require("./components/Edit/EditChecklist"));

var _PreviewChecklist = _interopRequireDefault(require("./components/PreviewChecklist"));

var _Error = _interopRequireDefault(require("./components/Error"));

var _button = require("@jsluna/button");

var _grid = require("@jsluna/grid");

var _constants = require("./utils/constants");

var _utils = require("./utils");

require("@jsainsburyplc/activity-checklist/css/main.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Checklist = function Checklist(_ref) {
  var maxItems = _ref.maxItems,
      onSave = _ref.onSave,
      mode = _ref.mode,
      content = _ref.content,
      newItemTitle = _ref.newItemTitle,
      newItemDescription = _ref.newItemDescription,
      previewTitle = _ref.previewTitle;

  var _useState = (0, _react.useState)(mode),
      checklistMode = _useState[0],
      setChecklistMode = _useState[1];

  var _useState2 = (0, _react.useState)([]),
      checklistItems = _useState2[0],
      setChecklistItems = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      isContentValid = _useState3[0],
      setIsContentValid = _useState3[1];

  (0, _react.useEffect)(function () {
    setChecklistItems((0, _utils.parseChecklistItemsFromContent)(content, setIsContentValid));
    setChecklistMode(mode);
  }, [content, mode]);

  var onSaveChecklist = function onSaveChecklist(checklistItems) {
    setChecklistItems(checklistItems);
    setChecklistMode(_constants.CHECKLIST_MODE.PREVIEW);
    onSave(checklistItems.map(function (item) {
      delete item.error;
      return item;
    }));
  };

  if (!isContentValid) {
    return /*#__PURE__*/_react.default.createElement(_Error.default, {
      className: "ln-u-margin-bottom*2",
      message: "Invalid checklist content!"
    });
  }

  switch (checklistMode) {
    case _constants.CHECKLIST_MODE.PREVIEW:
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_PreviewChecklist.default, {
        items: checklistItems,
        title: previewTitle
      }), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
        size: {
          default: '1/1',
          md: '1/4'
        },
        style: {
          paddingLeft: 0
        }
      }, /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
        onClick: function onClick() {
          return setChecklistMode(_constants.CHECKLIST_MODE.EDIT);
        },
        className: "ln-c-button--full ln-u-bg-color-white ln-u-margin-ends*2"
      }, "Edit checklist")));

    case _constants.CHECKLIST_MODE.EDIT:
      return /*#__PURE__*/_react.default.createElement(_EditChecklist.default, {
        newItemDescription: newItemDescription,
        newItemTitle: newItemTitle,
        onSave: onSaveChecklist,
        checklistItemsInitState: checklistItems,
        maxItems: maxItems
      });
  }
};

Checklist.propTypes = {
  maxItems: _propTypes.default.number,
  onSave: _propTypes.default.func.isRequired,
  newItemTitle: _propTypes.default.string,
  newItemDescription: _propTypes.default.string,
  mode: _propTypes.default.oneOf(Object.values(_constants.CHECKLIST_MODE)),
  content: _propTypes.default.string,
  previewTitle: _propTypes.default.string
};
Checklist.defaultProps = {
  maxItems: 20,
  newItemTitle: null,
  newItemDescription: null,
  mode: _constants.CHECKLIST_MODE.EDIT,
  content: null,
  previewTitle: null
};
var _default = Checklist;
exports.default = _default;